import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardText } from 'react-md';

import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';

const style = { maxWidth: 320 };

const EditBankAccounts = () => <div className="content">not available</div>;

const BlockBankAccounts = ({ party, strings, mode, setViewMode, id }) =>
  mode === 'view' ? (
    <div className="content" key={`bank-accounts-${id}`}>
      {party && Array.isArray(party.bankAccounts)
        ? party.bankAccounts.map(bankAccount => (
          <Card style={style} className="md-block-centered" key={bankAccount.id}>
            <CardText>
              <div className="group">
                <ItemField
                  label={strings['parties.grid.column.iban.label'] || 'IBAN'}
                  value={bankAccount.number}
                  name="bankAccount.number"
                  type="string"
                  optional
                />
                <ItemField
                  label={strings['parties.grid.column.bic.label'] || 'BIC'}
                  value={bankAccount.bank ? bankAccount.bank.bic : undefined}
                  name="bankAccount.bank.bic"
                  type="string"
                  optional
                />
              </div>
            </CardText>
          </Card>
          ))
        : ''}
    </div>
  ) : (
    <EditBankAccounts setViewMode={setViewMode}>not available</EditBankAccounts>
  );

BlockBankAccounts.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired,
  setViewMode: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

BlockBankAccounts.defaultProps = {
  party: {},
  strings: {}
};

const config = {
  title: 'party.edit.block.bank-accounts.label',
  defaultTitle: 'Bank Accounts',
  name: 'bank-accounts',
  active: false
};

export default withToggleView(BlockBankAccounts, config);
